<template>
  <div class="sequence-accueil">
    <h2 class="subtitle">Options du site internet</h2>
    <hr />
    <violet-bar>Séquence d'accueil</violet-bar>
    <div class="box squarebox">
      <vue-draggable
        :value="list"
        @input="list = $event"
        style="display: flex; flex-wrap: wrap;"
        :handle="'.handle'"
      >
        <div
          v-for="(couple, index) in list"
          style="flex: 0 0 33.3%; padding: 0.75em;"
          :key="couple.uuid"
        >
          <div
            class="squarebox"
            style="position:relative; display: flex; flex-wrap: wrap"
          >
            <span
              class="delete"
              style="position:absolute;top: -8px;right: -8px"
              @click="remove_couple(couple.uuid)"
            ></span>
            <span
              class="handle"
              style="position:absolute; left: -8px; top: -8px; background: antiquewhite; border-radius: 4px; height: 16px; width: 16px; font-size: 9px; text-align: center"
              >{{ index }}</span
            >
            <div class="squarebox" style="flex: 0 0 50%;">
              <label for="" class="label is-small">Image de gauche</label>
              <picture-input
                style="float: right"
                :item="(couple.left.picture && couple.left.picture.id) || null"
                :small="true"
                @update="couple.left.picture = $event"
              ></picture-input>
              <label for="" style="clear: both" class="label is-small"
                >Légende</label
              >
              <input
                class="input is-small"
                type="text"
                v-model="couple.left.text"
              />
              <label for="" class="label is-small">URL (ou vide)</label>
              <input
                class="input is-small"
                type="text"
                v-model="couple.left.link"
              />
            </div>
            <div class="squarebox" style="flex: 0 0 50%;">
              <label for="" class="label is-small">Image de droite</label>
              <picture-input
                :item="
                  (couple.right.picture && couple.right.picture.id) || null
                "
                :small="true"
                @update="couple.right.picture = $event"
              ></picture-input>
              <label for="" class="label is-small">Légende</label>
              <input
                class="input is-small"
                type="text"
                v-model="couple.right.text"
              />
              <label for="" class="label is-small">URL (ou vide)</label>
              <input
                class="input is-small"
                type="text"
                v-model="couple.right.link"
              />
            </div>
            <div class="buttons" style="flex: 0 0 100%;">
              <button class="button is-small" @click="swap_in_couple(couple.uuid)">
                Intervertir ces deux images
              </button>
            </div>
          </div>
        </div>
      </vue-draggable>
      <button class="is-info is-small button" @click="add_couple">
        Ajouter un groupe
      </button>
    </div>
    <div class="buttons">
      <button class="button is-primary" @click="this.save">Enregistrer</button>
    </div>
  </div>
</template>
<script>
import PictureInput from "../../components/Form/PictureInput";
import VioletBar from "../Projects/VioletBar";
import VueDraggable from "vuedraggable";
import { types } from "../../store/actions/misc";
import { genUuidV4 } from "../../util/uuidv4";

const makeCouple = () => ({
  left: { picture: null, text: "", link: "" },
  right: { picture: null, text: "", link: "" },
  uuid: genUuidV4()
});

const defaultList = () => [makeCouple(), makeCouple()];

export default {
  name: "sequence_accueil",
  components: { PictureInput, VioletBar, VueDraggable },
  data() {
    return {
      list: [makeCouple(), makeCouple()]
    };
  },
  methods: {
    remove_couple(uuid) {
      this.list = this.list.filter(c => c.uuid !== uuid);
    },
    add_couple() {
      this.list.push(makeCouple());
    },
    swap_in_couple(uuid) {
      this.list = this.list.map(c => {
        if (c.uuid === uuid) {
          const b = c.right;
          c.right = c.left;
          c.left = b;
        }
        return c;
      });
    },
    async fetch() {
      try {
        this.$set(this, "list", await this.$store.dispatch(types.GET_SEQUENCE));
      } catch (e) {
        this.$set(this, "list", defaultList());
      }
    },
    async save() {
      await this.$store.dispatch(types.SET_SEQUENCE, this.list);
      await this.fetch();
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>
